<template>
<div class="crop-production__desc description__title_blue">
  <product-title>{{descTitleServises}}</product-title>

  <div class="crop-production__col crop-production__col-top">
    <description :description="descriptionLeft" :descTitleShow="descTitleShow"
     class="check-list__item_full-width" />
  </div>

  <div class="crop-production__col crop-production__col-bottom">
    <description :description="descriptionRight" :descTitleShow="descTitleShow"
     class="check-list__item_full-width" />
  </div>

  <slot></slot>
</div>
</template>

<script>
import Description from '@/components/shared/listing/DescListing.vue';
import ProductTitle from '@/components/shared/ProductTitle.vue';

export default {
  data() {
    return {
      descTitleShow: false,

      descTitleServises: 'ОСНОВНОЙ ПЕРЕЧЕНЬ УСЛУГ, ПРЕДОСТАВЛЯЕМЫХ КОМПАНИЯМИ Agrotech И Ctrl2GO С ИСПОЛЬЗОВАНИЕМ СИСТЕМЫ CLASS:',

      descriptionLeft: [{
        text: 'определение общих посевных площадей сельскохозяйственных культур в масштабах единиц административно-территориального деления государства',
      },
      {
        text: 'определение посевных площадей конкретных сельскохозяйственных культур в масштабах: поле / хозяйство / единицы административно-территориального деления государства (далее АТД)',
      },
      {
        text: 'еженедельный уточняющийся прогноз урожайности и собранного урожая сельскохозяйственных культур в масштабах: поле / хозяйство / единицы АТД ',
      },
      {
        text: 'оценка урожайности сельскохозяйственных культур во время уборки урожая в масштабах: поле / хозяйство / единицы АТД',
      },
      {
        text: 'оценка собранного урожая сельскохозяйственных культур во время уборки урожая в масштабах: поле / хозяйство / единицы АТД',
      },
      {
        text: 'мониторинг состояния посевов и информирование клиентов по полученным результатам',
      },
      {
        text: 'определение стадий роста и развития культур (этапов органогенеза) в масштабах поля',
      },
      {
        text: 'определение типов биотического и абиотического стресса растений',
      },
      ],

      descriptionRight: [{
        text: 'оценка понесённого ущерба сельскохозяйственными товаропроизводителями от чрезвычайных ситуаций природного характера (экспертиза)',
      },
      {
        text: 'ранжирование сельскохозяйственных территорий / угодий по представленным методикам заказчиков (страховых компаний, банков и т.д.)',
      },
      {
        text: 'метеорологический мониторинг сельхоз угодий (территорий), информирование клиентов о состоянии и прогнозе погоды, оповещение о прогнозе наступления неблагоприятных и опасных для ведения сельского хозяйства метеорологических условиях',
      },
      {
        text: 'предоставление клиентам рекомендаций по проведению агротехнических мероприятий',
      },
      {
        text: 'автоматическая векторизация полей на территориях с отсутствием цифрового кадастра земель сельскохозяйственного назначения, выявление коллизий между кадастром и реальными полями',
      },
      {
        text: 'услуги по предоставлению доступа к данным дистанционного зондирования Земли и инструментам их обработки в формате подписки.',
      },
      ],
    };
  },
  components: {
    Description,
    ProductTitle,
  },
};
</script>

<style lang="scss" scoped>
$light-gray: #D5D6D7;
$blue: #4DB6BC;

.crop-production {
  position: relative;
  color: $light-gray;

  &:deep(.description__title) {
    color: $blue;
  }

  &__desc {
    padding: 30px 180px;
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-areas:
      "t t t t t t"
      "a a a b b b"
      ". c d d e .";

    @media (max-width: 720px) {
      grid-template-areas:
        "t t t t t t"
        "c c c c c c"
        "a a a a a a"
        "d d d d d d"
        "b b b b b b"
        "e e e e e e";
    }

    &:deep(.description__container) {
      padding: 0;
    }

    &:deep(.title-product) {
      margin: 0 10px 30px 0;
      grid-area: t;
    }

    @media (max-width: 1275px) {
      padding: 0 50px;
    }

    @media (max-width: 720px) {
      flex-direction: column;
    }

    @media (max-width: 480px) {
      padding: 0 30px;
    }
  }

  .title-product {
    grid-area: t;
  }

  &__col {
    padding: 20px 0;
    margin: 0 20px 0 0;

    @media (max-width: 720px) {
      margin: 0;
    }

    &:last-child {
      margin: 0;
    }

    &-top {
      grid-area: a;
    }

    &-bottom {
      grid-area: b;
    }
  }
}
</style>
